(() => {
  const ensureGalleryAlignmentStyles = () => {
    if (document.getElementById('cp-main-gallery-alignment')) return;

    const style = document.createElement('style');
    style.id = 'cp-main-gallery-alignment';
    style.textContent = `
      [id^='MainProduct-'] media-gallery > slider-component:first-of-type {
        width: 100%;
        max-width: 100%;
      }

      [id^='MainProduct-'] media-gallery > slider-component:first-of-type .product__media-list {
        width: 100% !important;
        max-width: 100% !important;
        margin-left: 0 !important;
        margin-right: 0 !important;
        padding-left: 0 !important;
        padding-right: 0 !important;
        column-gap: 0 !important;
      }

      [id^='MainProduct-'] media-gallery > slider-component:first-of-type .product__media-item {
        box-sizing: border-box !important;
        margin-left: 0 !important;
        margin-right: 0 !important;
        padding-left: 0 !important;
        padding-right: 0 !important;
        justify-content: center !important;
      }

      [id^='MainProduct-'] media-gallery > slider-component:first-of-type .product-media-container,
      [id^='MainProduct-'] media-gallery > slider-component:first-of-type .product__modal-opener,
      [id^='MainProduct-'] media-gallery > slider-component:first-of-type .product__media {
        width: 100% !important;
        max-width: 100% !important;
        margin-left: auto !important;
        margin-right: auto !important;
      }

      [id^='MainProduct-'] media-gallery > slider-component:first-of-type .product__media img {
        width: 100% !important;
        left: 0 !important;
        right: 0 !important;
        object-position: 50% 50% !important;
      }

      @media screen and (min-width: 750px) {
        [id^='MainProduct-'] media-gallery > slider-component:first-of-type .product__media-item.is-active {
          width: 100% !important;
          max-width: 100% !important;
          flex-basis: 100% !important;
        }
      }
    `;
    document.head.appendChild(style);
  };

  const enhanceVariantCards = (root = document) => {
    root.querySelectorAll("[id^='MainProduct-'] variant-selects .product-form__input--pill").forEach((fieldset) => {
      fieldset.classList.add('cp-supply-picker');
    });
  };

  const cleanEmptySubscriptionContainers = (card) => {
    card.querySelectorAll('div, ul, ol, p').forEach((element) => {
      if (element === card) return;
      if (element.matches('.custom_radio_button') || element.querySelector('.custom_radio_button')) {
        element.classList.remove('cp-subscription-empty');
        return;
      }

      const text = element.textContent.replace(/\u00a0/g, ' ').trim();
      const hasVisibleContent = Boolean(
        element.querySelector('a, button, select, textarea, img, picture, video, svg')
      );

      element.classList.toggle('cp-subscription-empty', !text && !hasVisibleContent);
    });
  };

  const enhanceSubscriptionCards = (root = document) => {
    const blocks = root.querySelectorAll
      ? root.querySelectorAll("[id^='MainProduct-'] .shopify_subscriptions_app_block")
      : [];

    const isAppVisibleRadio = (radio) => {
      const style = window.getComputedStyle(radio);
      return (
        style.display !== 'none' &&
        style.visibility !== 'hidden' &&
        Number.parseFloat(style.opacity || '1') > 0 &&
        radio.getClientRects().length > 0
      );
    };

    const depthInside = (element, ancestor) => {
      let depth = 0;
      let current = element;
      while (current && current !== ancestor) {
        depth += 1;
        current = current.parentElement;
      }
      return depth;
    };

    blocks.forEach((block) => {
      block.querySelectorAll('.cp-subscription-primary-radio, .cp-subscription-secondary-radio--single').forEach((radio) => {
        radio.classList.remove('cp-subscription-primary-radio', 'cp-subscription-secondary-radio--single');
      });

      block.querySelectorAll('fieldset').forEach((fieldset) => {
        const radioGroups = new Map();

        fieldset.querySelectorAll("input[type='radio']").forEach((radio) => {
          if (!(radio instanceof HTMLInputElement)) return;

          let card = radio;
          while (
            card.parentElement &&
            card.parentElement !== fieldset &&
            card.parentElement.parentElement !== fieldset
          ) {
            card = card.parentElement;
          }

          if (card.parentElement?.parentElement !== fieldset) return;
          if (!radioGroups.has(card)) radioGroups.set(card, []);
          radioGroups.get(card).push(radio);
        });

        radioGroups.forEach((radios, card) => {
          card.classList.add('cp-subscription-card');

          const visibleRadios = radios.filter(isAppVisibleRadio);
          const primaryRadio = (visibleRadios.length ? visibleRadios : radios)
            .slice()
            .sort((a, b) => depthInside(a, card) - depthInside(b, card))[0];

          if (!primaryRadio) return;
          primaryRadio.classList.add('cp-subscription-primary-radio');

          const radioType = primaryRadio.dataset.radioType || '';
          const cardText = card.textContent.replace(/\s+/g, ' ').trim().toLowerCase();
          const isOneTime = radioType === 'one_time_purchase' || cardText.includes('one-time purchase') || cardText.includes('one time purchase');
          card.classList.toggle('cp-subscription-card--one-time', isOneTime);
          card.classList.toggle('cp-subscription-card--subscription', !isOneTime);
          cleanEmptySubscriptionContainers(card);

          const secondaryRadios = radios.filter((radio) => radio !== primaryRadio);
          if (secondaryRadios.length === 1) {
            secondaryRadios[0].classList.add('cp-subscription-secondary-radio--single');
          }

          if (card.dataset.cpSubscriptionClickable === 'true') return;
          card.dataset.cpSubscriptionClickable = 'true';

          card.addEventListener('click', (event) => {
            const interactive = event.target.closest('a, button, select, textarea');
            if (interactive || event.target === primaryRadio || event.target.closest('label')) return;
            if (primaryRadio.disabled) return;

            primaryRadio.click();
            try {
              primaryRadio.focus({ preventScroll: true });
            } catch (error) {
              primaryRadio.focus();
            }
          });
        });
      });
    });
  };

  const enhanceInstantVariantMedia = (root = document) => {
    const productRoots = root.matches?.("[id^='MainProduct-']")
      ? [root]
      : Array.from(root.querySelectorAll?.("[id^='MainProduct-']") || []);

    productRoots.forEach((productRoot) => {
      const preloadVariantMedia = () => {
        productRoot.querySelectorAll("variant-selects [data-cp-variant-media-map]").forEach((script) => {
          try {
            const variants = JSON.parse(script.textContent || '[]');
            variants.forEach((variant) => {
              if (!variant?.media_url) return;
              const image = new Image();
              image.decoding = 'async';
              image.src = variant.media_url;
            });
          } catch (error) {
            console.warn('Unable to preload variant media.', error);
          }
        });
      };

      preloadVariantMedia();

      if (productRoot.dataset.cpInstantVariantMedia === 'true') return;
      productRoot.dataset.cpInstantVariantMedia = 'true';

      productRoot.addEventListener(
        'change',
        (event) => {
          const variantSelects = event.target.closest?.('variant-selects');
          if (!variantSelects || !productRoot.contains(variantSelects)) return;

          const mapScript = variantSelects.querySelector('[data-cp-variant-media-map]');
          if (!mapScript) return;

          let variants;
          try {
            variants = JSON.parse(mapScript.textContent || '[]');
          } catch (error) {
            return;
          }

          const selectedOptions = Array.from(
            variantSelects.querySelectorAll('.product-form__input')
          )
            .map((container) => {
              if (container.matches('fieldset')) {
                return container.querySelector("input[type='radio']:checked")?.value ?? null;
              }
              return container.querySelector('select')?.value ?? null;
            })
            .filter((value) => value !== null);

          const variant = variants.find(
            (item) =>
              Array.isArray(item.options) &&
              item.options.length === selectedOptions.length &&
              item.options.every((value, index) => value === selectedOptions[index])
          );

          if (!variant) return;

          const variantAvailable = variant.available !== false;
          const sectionId = variantSelects.dataset.section;

          productRoot
            .querySelectorAll(
              `#product-form-${CSS.escape(sectionId)} input[name='id'], #product-form-installment-${CSS.escape(sectionId)} input[name='id']`
            )
            .forEach((input) => {
              const nextValue = String(variant.id);
              if (input.value !== nextValue) {
                input.value = nextValue;
                input.dispatchEvent(new Event('change', { bubbles: true }));
              }
              input.disabled = !variantAvailable;
            });

          const productForm = productRoot.querySelector('product-form');
          productForm?.toggleSubmitButton(
            !variantAvailable,
            variantAvailable ? undefined : window.variantStrings.soldOut
          );

          if (!variant?.media_id) return;

          const gallery = productRoot.querySelector('media-gallery');
          if (!gallery?.setActiveMedia) return;

          gallery.setActiveMedia(
            `${sectionId}-${variant.media_id}`,
            false
          );
        },
        true
      );
    });
  };

  const boot = () => {
    ensureGalleryAlignmentStyles();
    enhanceVariantCards();
    enhanceSubscriptionCards();
    enhanceInstantVariantMedia();

    document.querySelectorAll("[id^='MainProduct-']").forEach((root) => {
      let scheduled = false;
      const observer = new MutationObserver(() => {
        if (scheduled) return;
        scheduled = true;
        requestAnimationFrame(() => {
          scheduled = false;
          enhanceVariantCards(root);
          enhanceSubscriptionCards(root);
          enhanceInstantVariantMedia(root);
        });
      });

      observer.observe(root, { childList: true, subtree: true });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', (event) => {
    ensureGalleryAlignmentStyles();
    enhanceVariantCards(event.target);
    enhanceSubscriptionCards(event.target);
    enhanceInstantVariantMedia(event.target);
  });
})();